module.exports = __webpack_public_path__ + "static/media/7.13cc49a9.jpg";